import { render } from "./samplemap.vue?vue&type=template&id=117272a4&scoped=true"
import script from "./samplemap.vue?vue&type=script&lang=js"
export * from "./samplemap.vue?vue&type=script&lang=js"

import "./samplemap.vue?vue&type=style&index=0&id=117272a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117272a4"]])

export default __exports__